import React, { useState } from "react";
import { Table, Divider, Tag, Popconfirm, Typography } from "antd";
const { Text } = Typography;
import moment from "moment";
import VehicleName from "../../../VehicleName";
import { formatVehicleNameOnly } from "../../../../utils/vehicleDisplayName";

export default function QuotationTable(props) {
  const { pagination, dataSource, spinner, openModal, deleteAccess, modify, openReassignModal } = props;

  const column = [
    {
      title: "Quotation Id",
      dataIndex: "quotationId",
      key: "quotationId",
      width: 150,
      render: (record) => (
        <span style={{ whiteSpace: "nowrap" }}>{record}</span>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer",
      key: "customer",
      render: (record, data) => {
        const name =
          data.customerName ||
          (data.proCustomer ? data.proCustomer.name : record && record.name);
        return <span>{name}</span>;
      },
    },
  {
  title: "Vehicle",
  dataIndex: "vehicle",
  key: "vehicle",
  width: 286,
  render: (record) =>
    record &&
    record?.map((value, index) => {
      const displayName = formatVehicleNameOnly(value.vehicleDetail || value);
      return (
        <Tag color="blue" key={index} style={{ marginBottom: "4px", whiteSpace: "normal", maxWidth: "100%" }}>
          <VehicleName nameOnly value={value.vehicleDetail || value}>
            {displayName}
          </VehicleName>
        </Tag>
      );
    }),
},
    {
      title: "Mobile No",
      dataIndex: "customer",
      key: "phone",
      render: (record, data) => {
        const phone =
          data.quotationPhone ||
          (data.proCustomer
            ? data.proCustomer.phone ||
              data.proCustomer.refferedBy.contacts[0].phone
            : record && record.contacts && record.contacts[0].phone);
        return <span>{phone}</span>;
      },
    },

    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "joinedOn",
      render: (record) => (
        <span>{moment(new Date(record)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      title: "Created By",
      key: "createdBy",
      render: (record) => {
        const followUps = record?.followUp || record?.followUps || [];
        const firstFollowUp = followUps[followUps.length - 1];
        const employeeName = firstFollowUp?.user?.profile?.employeeName || "-";
        return <span>{employeeName}</span>;
      },
    },
    {
      title: "Action",
      render: (record) => (
        <div>
             {modify &&
             <>
             <span
             onClick={(event) => {
               event.stopPropagation();
               openReassignModal(record.id,true);
             }}
             className="linkylink"
           >
             Reassign
           </span>
           <Divider type="vertical"/>
             </>
           }
          {deleteAccess ? (
            <Popconfirm
              title="Do you want to delete this Quotation?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                props.delete(record.id);
              }}
            >
              <span
                onClick={(event) => event.stopPropagation()}
                className="linkylink"
              >
                Delete
              </span>
            </Popconfirm>
          ) : (
            <Text strong disabled>
              No Actions Given
            </Text>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      rowKey={(record) => record.id}
      pagination={pagination}
      columns={column}
      dataSource={dataSource}
      loading={spinner}
      style={{ cursor: "pointer" }}
      scroll={{ x: 768 }}
      onRow={(record) => ({
        onClick: () => openModal(record.id, false),
      })}
    />
  );
}
